import { PAGE_PATH_LOGIN, PAGE_PATH_SALES_AGENT_LOGIN, QUERY_PARAM_PREVIOUS_PATH } from '../constants'
import {
	addTrailingSlash,
	isErrorPage,
	isMaintenancePage,
	isLoginPage,
	isRegisterPage,
	isResetPasswordPage,
	isSalesAgentLoginPage,
	isSalesAgentResetPasswordPage,
	removeTrailingSlashes,
	cleanPathFromParamsAndHashtag,
} from '../utils'

const isAllowedPath = ({ asPath, allowedPaths = [], mode, pathname }) =>
	isErrorPage(pathname) ||
	isMaintenancePage(pathname) ||
	isLoginPage(addTrailingSlash(asPath)) ||
	isResetPasswordPage(addTrailingSlash(asPath)) ||
	isSalesAgentLoginPage(addTrailingSlash(asPath)) ||
	isSalesAgentResetPasswordPage(addTrailingSlash(asPath)) ||
	!!allowedPaths?.find(
		(regexPath) =>
			(cleanPathFromParamsAndHashtag(removeTrailingSlashes(asPath)) === '' && regexPath === '^/$') ||
			cleanPathFromParamsAndHashtag(removeTrailingSlashes(asPath)).match(regexPath)
	) ||
	(mode === 'login-register' && isRegisterPage(addTrailingSlash(asPath)))

const isAllowedPathsSalesAgentOnly = ({ asPath, allowedPaths = [] }) =>
	!!['^/sales-agent/?$', '^/sales-agent/.+', ...allowedPaths]?.find(
		(regexPath) =>
			(cleanPathFromParamsAndHashtag(removeTrailingSlashes(asPath)) === '' && regexPath === '^/$') ||
			cleanPathFromParamsAndHashtag(removeTrailingSlashes(asPath)).match(regexPath)
	)

// TODO: Migrate to Next.js middleware along with all Express middleware.
export const redirectToLogin = ({
	isCustomerLoggedIn,
	isSalesAgentLoggedIn,
	store,
	restrictionConfig = {},
	pathname,
	asPath,
}) => {
	const { enabled, allowedPaths, allowedPathsSalesAgentOnly, mode } = restrictionConfig

	if (!store) return false
	const redirect =
		enabled &&
		!isCustomerLoggedIn &&
		!isSalesAgentLoggedIn &&
		!isAllowedPath({
			asPath,
			allowedPaths,
			mode,
			pathname,
		})

	const redirectSalesAgentOnly =
		enabled &&
		!isSalesAgentLoggedIn &&
		isAllowedPathsSalesAgentOnly({
			asPath,
			allowedPaths: allowedPathsSalesAgentOnly,
		})

	if (redirect || redirectSalesAgentOnly) {
		const { path: storePath } = store
		const storePathWithoutTrailingSlash = removeTrailingSlashes(storePath)

		const searchParams = new URLSearchParams({
			[QUERY_PARAM_PREVIOUS_PATH]: `${storePathWithoutTrailingSlash}${asPath}`,
		}).toString()

		const destination = `${storePathWithoutTrailingSlash}${
			redirectSalesAgentOnly ? PAGE_PATH_SALES_AGENT_LOGIN : PAGE_PATH_LOGIN
		}?${searchParams}`

		return {
			destination,
			permanent: false,
		}
	} else {
		return false
	}
}
